var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content',{attrs:{"page-title":_vm.$t('newMap'),"map-name":_vm.$t('noNameMap'),"submit-in-progress":_vm.submitInProgress},on:{"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }